import { render, staticRenderFns } from "./PromotionDeletionPopup.vue?vue&type=template&id=bcc68e24&scoped=true&"
import script from "./PromotionDeletionPopup.vue?vue&type=script&lang=js&"
export * from "./PromotionDeletionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc68e24",
  null
  
)

export default component.exports